import React from 'react'
import Sidebar from '../../components/Sidebar'
import PayoutTable from './components/PayoutTable'

const PayoutReview = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      {/* Sidebar handles its own desktop/mobile rendering */}
      <Sidebar />
      
      {/* Main content — scrolls independently */}
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Payouts Manual Review</h1>

        <div className="">
          <PayoutTable />
        </div>
      </div>
    </div>
  )
}

export default PayoutReview